import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { TranslateModule } from '@ngx-translate/core';
import { CityInputComponent } from './city-input/city-input.component';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { CountrySelectComponent } from './country-select/country-select.component';
import { LogisticAreaComponent } from './logistic-area/logistic-area.component';
import { NodeSelectComponent } from './node-select/node-select.component';
import { OrderStateLabelComponent } from './order-state-label/order-state-label.component';
import { SpinnerComponent } from './spinner/spinner.component';
import { TxDefSelectComponent } from './tx-def-select/tx-def-select.component';
import { ZbsValuelistEntrySelectComponent } from './zbs-valuelist-entry-select/zbs-valuelist-entry-select.component';
import { ZipCodeInputComponent } from './zip-code-input/zip-code-input.component';

@NgModule({
  declarations: [LogisticAreaComponent, CountrySelectComponent, SpinnerComponent,
    ConfirmDialogComponent, TxDefSelectComponent, NodeSelectComponent, ZipCodeInputComponent, CityInputComponent, OrderStateLabelComponent, ZbsValuelistEntrySelectComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    TranslateModule.forChild()
  ],
  exports: [LogisticAreaComponent, CountrySelectComponent, SpinnerComponent, ConfirmDialogComponent, TxDefSelectComponent, NodeSelectComponent, ZipCodeInputComponent, CityInputComponent, OrderStateLabelComponent, ZbsValuelistEntrySelectComponent]
})
export class SharedModule { }
